import { render, staticRenderFns } from "./Perf.vue?vue&type=template&id=8c375c70&"
import script from "./Perf.vue?vue&type=script&lang=js&"
export * from "./Perf.vue?vue&type=script&lang=js&"
import style0 from "./Perf.vue?vue&type=style&index=0&id=8c375c70&prod&lang=scss&"
import style1 from "./Perf.vue?vue&type=style&index=1&id=8c375c70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports